import { Component } from '@theme/component';

class FiveToeBundleSticky extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.frame = 0;
    this.target = null;
    this.abort = new AbortController();
    this.scope = this.closest('.shopify-section');
    this.observer = new IntersectionObserver(() => this.update());
    this.mutations = new MutationObserver(() => this.bindTarget());
    this.mutations.observe(this.scope, { subtree: true, childList: true });
    window.addEventListener('scroll', () => this.schedule(), { passive: true, signal: this.abort.signal });
    window.addEventListener('resize', () => this.schedule(), { passive: true, signal: this.abort.signal });
    this.bindTarget();
  }
  bindTarget() {
    const target = this.scope.querySelector('.product-details [ref="addToCartButton"]');
    if (target !== this.target) {
      this.observer.disconnect();
      this.target = target;
      if (target) this.observer.observe(target);
    }
    this.update();
  }
  schedule() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
  }
  update() {
    if (!this.target?.isConnected) { this.hidden = true; return; }
    const rect = this.target.getBoundingClientRect();
    const header = document.querySelector('header-component');
    const headerRect = header?.getBoundingClientRect();
    const top = headerRect && headerRect.top <= 1 ? Math.max(0, headerRect.bottom) : 0;
    this.hidden = !rect.height || rect.bottom > top;
  }
  returnToBundle(event) {
    const bundle = this.scope.querySelector('[data-rapi-selected-variants]') || this.scope.querySelector('#buy');
    if (!bundle) return;
    event.preventDefault();
    bundle.style.scrollMarginTop = '120px';
    bundle.setAttribute('tabindex', '-1');
    bundle.focus({ preventScroll: true });
    bundle.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  }
  disconnectedCallback() {
    this.observer?.disconnect(); this.mutations?.disconnect(); this.abort?.abort();
    cancelAnimationFrame(this.frame);
    this.frame = 0;
    super.disconnectedCallback();
  }
}
if (!customElements.get('five-toe-bundle-sticky')) customElements.define('five-toe-bundle-sticky', FiveToeBundleSticky);
